<script>
  import { onMount, createEventDispatcher } from 'svelte'
  import { ga } from '@beyonk/svelte-google-analytics'
  import { fly, fade } from 'svelte/transition'
  import { cubicInOut } from 'svelte/easing'
  import gsap from 'gsap'
  import { transformForm } from './Helpers'
  import AnimatedTitle from './components/AnimatedTitle.svelte'
  import AnimatedBlock from './components/AnimatedBlock.svelte'

  const dispatch = createEventDispatcher()

  let formComplete = false
  let formLoaded = true
  const formId = 3661

  onMount(() => {
    if (typeof window.MktoForms2 === 'undefined') return
    MktoForms2.loadForm('https://pages.verizonmedia.com', '118-OEW-181', formId, (form) => {
      formLoaded = true
      form.onSuccess((e) => {
        formComplete = true
        const formEl = form.getFormElem()[0]
        const email = formEl ? formEl.querySelector('input[type=email]')?.value : ''
        dispatch('formComplete', { formId, email })
        return false
      })
      form.onSubmit((e) => {
        try {
          ga.addEvent('form_submit_begin', {
            formId,
          })
        } catch (e2) {
          console.log(e2)
        }
      })
      transformForm(form)
    })
  })

  function clickButton() {
    const btnHeight = gsap.getProperty('.begin-btn-wrap', 'height')
    const formHeight = gsap.getProperty('form', 'height')
    gsap.fromTo(
      '.begin-btn-wrap',
      { height: btnHeight },
      { height: 3, width: '100%', ease: 'power2.inOut', duration: 0.4 }
    )
    gsap.fromTo(
      '.form-wrap',
      { height: 0 },
      {
        height: formHeight,
        ease: 'power2.inOut',
        duration: 0.4,
        onComplete: () => {
          gsap.set('.form-wrap', { height: 'auto' })
        },
      }
    )
    const fields = Array.from(document.querySelectorAll('.mktoFormRow, .mktoButtonRow'))
    fields.map((row, index) => {
      gsap.from(row, { opacity: 0, duration: 0.7, delay: index * 0.09 })
    })
    dispatch('formComplete', { formId: '0', email: 'test@example.com' })
  }
</script>

<section>
  <div class="rgrid-md-2-3 rgrid-lg-1-2">
    <div class="col">
      <AnimatedTitle class="large">Supercharge Your TV Strategy</AnimatedTitle>
      <AnimatedBlock>
        <p class="subtitle">Explore new insights and approaches to maximize performance of your TV advertising.</p>
      </AnimatedBlock>
      {#if formLoaded}
        <div class="btn-wrap begin-btn-wrap">
          <button
            class="begin-btn custom"
            on:click={clickButton}
            in:fly={{ x: -250, duration: 500, ease: cubicInOut, delay: 250 }}
          >
            <h3 class="title" in:fade={{ duration: 500, delay: 650 }}>Begin your 6-minute journey now.</h3>
            <div class="arrow" in:fly={{ x: -40, duration: 500, delay: 750 }}>
              <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g stroke="black" stroke-width="2">
                  <path d="M28.1111 15.5H0.5" />
                  <path d="M14.8887 1.5L28.8887 15.5L14.8887 29.5" />
                </g>
              </svg>
            </div>
          </button>
        </div>
      {/if}
      {#if !formComplete}
        <div class="form-wrap">
          <form id="mktoForm_{formId}"></form>
        </div>
      {/if}
    </div>
  </div>
</section>

<style>
  form {
    margin: 0 auto;
    width: 100%;
    display: block !important;
  }
  .begin-btn .title {
    margin: 0;
    font-weight: 600;
  }
  .begin-btn {
    background: white;
    padding: 20px;
    color: black;
    width: 100%;
    display: block;
  }
  .btn-wrap {
    margin-top: 2.5rem;
    overflow: hidden;
  }
  :global(form .mktoButtonWrap) {
    margin-left: 0 !important;
  }
  .arrow {
    padding-top: 65px;
  }
  .form-wrap {
    height: 0;
    overflow: hidden;
    margin-top: 16px;
  }
  @media (min-width: 768px) {
    .btn-wrap {
      width: 100%;
    }
  }
</style>
